// extracted by mini-css-extract-plugin
module.exports = {"box":"role_box_siFul","info":"role_info_1Yhan","sure":"role_sure_ypbXq"};